import { Colors } from "@/types/tags/Colors.js";
export const getRandomColor = (skipColor?: string): string => {
	if (Colors.length === 0) {
		return "#e0e0e0";
	}
	const randomTagColor = Math.floor(Math.random() * Colors.length);
	const newColor = Colors[randomTagColor];
	if (skipColor && newColor === skipColor) {
		return getRandomColor(skipColor);
	} else {
		return newColor;
	}
};
